/**
 * Confirm text when saved flex schedules share a product and overlap after
 * midnight (ENG-1970). Product names come from the cached product list.
 */
export const overnightOverlapWarning = (productIds: number[]): string => {
  let names: string[] = [];
  try {
    const products: { id: number; name: string }[] = JSON.parse(
      localStorage.getItem("products") || "[]"
    );
    const byId = new Map(products.map((product) => [product.id, product.name]));
    names = productIds.map((id) => byId.get(id) ?? `product ${id}`);
  } catch {
    names = productIds.map((id) => `product ${id}`);
  }
  return (
    `Two schedules both run ${names.join(
      ", "
    )} at the same time after midnight, ` +
    `so those alerts will arrive twice during the overlap. We recommend changing ` +
    `the schedule times so they don't overlap.\n\nSave anyway?`
  );
};
